import {type PartialOptions, type UIChild, UI} from "../../../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../../../stem-core/ui/Style";
import {StemDate} from "../../../../../stem-core/time/Date";
import {styleRule} from "../../../../../stem-core/decorators/Style";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {daysInWeek, rangeDayCalendarPadding, weekStartingDayIndex} from "../DateRangePickerConstants";
import {DashboardBaseInput} from "../../../../../core/ui/input/BaseInput.js";
import type {NodeAttributes} from "../../../../../stem-core/ui/NodeAttributes";

const referenceHours = 17;

const daysRowsCount = 6;

class DateCalendarMonthInputInterfaceStyle extends StyleSheet {
    @styleRule
    dayLabel = {
        color: this.themeProps.MERCHANT_2,
        textAlign: "center",
        paddingBottom: 10,
    };

    @styleRule
    month = {
        display: "flex",
        userSelect: "none",
        padding: `0 ${rangeDayCalendarPadding}px`
    };
}

interface DateCalendarMonthInputInterfaceOptions {
    monthDate?: StemDate;
    minDate?: StemDate;
    maxDate?: StemDate;
}

@registerStyle(DateCalendarMonthInputInterfaceStyle)
export class DateCalendarMonthInputInterface<ExtraOptions = {}>
        extends DashboardBaseInput<DateCalendarMonthInputInterfaceOptions & ExtraOptions> {
    hoverDate: StemDate | null = null;

    getDefaultOptions(): PartialOptions<DateCalendarMonthInputInterface> {
        return {
            ...super.getDefaultOptions(),
            monthDate: null,
            minDate: null,
            maxDate: null,
        }
    }

    extraNodeAttributes(attr: NodeAttributes) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.month);
    }

    addDay(date: StemDate, count: number) {
        date.setHours(referenceHours);
        date.setDate(date.getDate() + count);
        return date;
    }

    render() {
        let date = new StemDate(this.options.monthDate);
        date.setDate(1);
        for (let i = 0; i <= 7; i += 1) {
            if (date.getDay() !== weekStartingDayIndex) {
                date = this.addDay(date, -1);
            } else {
                break;
            }
        }

        const elements = [];
        for (let i = 0; i < daysInWeek; i += 1) {
            elements.push(this.renderDayColumn(date));
            date = this.addDay(date, 1);
        }

        return elements;
    }

    renderDayElement(date: StemDate): UIChild {
        throw "Implement";
    }

    renderDayColumn(date: StemDate) {
        const {styleSheet} = this;
        const elements = [];
        const inputDate = new StemDate(date);
        elements.push(<div className={styleSheet.dayLabel}>{inputDate.format("dd")}</div>);

        for (let i = 0; i < daysRowsCount; i += 1) {
            elements.push(this.renderDayElement(new StemDate(inputDate)));
            this.addDay(inputDate, 7);
        }

        return <div>{elements}</div>;
    }

    onDateHover(date: StemDate) {
        this.hoverDate = date;
        this.enqueueRedraw();
    }

    onDateSelection(date: StemDate) {
        throw "Implement";
    }
}
